import { AfterViewInitDirective } from './../../../directives/after-view-init.directive';
import { FormGroup } from '@angular/forms';
import { WorkspaceServiceService } from './../../../services/workspace-service.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ITemplate } from './../../template-preview/template-preview.component';
import { Component, OnInit, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { AChartComponent } from '../../achart/achart.component';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import * as $ from "jquery";
import "malihu-custom-scrollbar-plugin/jquery.mCustomScrollbar.concat.min.js";
import { ShowNewTemplateModal } from '../ChartOptionsModal/show-new-template-modal';

@Component( {
  selector: 'templates-modal',
  template: require('./templates-modal.component.html'),
  styles: [ require('./templates-modal.component.css') ],
} )
export class TemplatesModalComponent implements OnInit {
  test () { alert( 'mainwinit' ) }
  acharts!: AChartComponent[];
  defaultTemplates: ITemplate[] =
    [
      {
        name: 'Default',
        background: '#1D2A33',
        font: '#F6F2F2',
        grid: '#F6F2F2',
        minorGrid: '#F6F2F2',
        axis: '#F6F2F2',
        chartingPriceline: '#F6F2F2',
        candleBorder: '#191818',
        bearishCandle: '#E70304',
        bullishCandle: '#0E835E',
        crosshair: '#F6F2F2'
      },
      {
        name: 'Light',
        background: '#F3F9FF',
        font: '#000000',
        grid: '#636363',
        minorGrid: '#42484D',
        axis: '#636363',
        chartingPriceline: '#000000',
        candleBorder: '#191818',
        bearishCandle: '#E70304',
        bullishCandle: '#0E835E',
        crosshair: '#000000'
      }
    ];

  get userTemplates () {
    return this.workspaceService.data.userTemplates;
  }

  selectedTemplate: ITemplate | undefined;

  get selectedOrDefaultTemplate () {
    return this.selectedTemplate || this.defaultTemplates[ 0 ];
  }

  deleteConfirmation?: ITemplate;

  get mainWindow () {
    return this.deleteConfirmation == null;
  }

  constructor ( public activeModal: NgbActiveModal, public modalService: NgbModal, public workspaceService: WorkspaceServiceService ) { ( window as any ).templatesModal = this; }

  ngOnInit () {
  }

  delete ( template: ITemplate, confirmed = false ) {
    if ( !confirmed ) {
      this.deleteConfirmation = template;
      return;
    }

    if ( this.selectedTemplate == template )
      this.selectedTemplate = undefined;

    this.workspaceService.data.removeUserTemplate( template );
    this.deleteConfirmation = undefined;
  }

  canRemove ( template: ITemplate ) {
    return this.defaultTemplates.indexOf( template ) == -1;
  }

  selectTemplate ( template: ITemplate ) {
    this.selectedTemplate = template;
  }

  newTemplate ( template?: ITemplate, editMode = false ) {
    ShowNewTemplateModal( this.modalService, template || this.selectedOrDefaultTemplate, this.workspaceService.data.mobileMode, editMode ).then( ( formGroup: FormGroup ) => {
      const newTemplate: ITemplate = {
        name: `${ formGroup.value.templateName }`,
        background: `${ formGroup.value.BackgroundColor }`,
        font: `${ formGroup.value.FontColor }`,
        grid: `${ formGroup.value.GridColor }`,
        minorGrid: `${ formGroup.value.MinorGridColor }`,
        axis: `${ formGroup.value.AxisColor }`,
        chartingPriceline: `${ formGroup.value.LineSeriesColor }`,
        candleBorder: `${ formGroup.value.CandleStickSerieBorderColor }`,
        bearishCandle: `${ formGroup.value.CandleStickSerieFallingColor }`,
        bullishCandle: `${ formGroup.value.CandleStickSerieRisingColor }`,
        crosshair: `${ formGroup.value.CrosshairColor }`
      }

      if ( ( formGroup as any ).editMode ) {
        const baseTemplate = ( formGroup as any ).template as ITemplate;
        this.workspaceService.data.replaceUserTemplate( baseTemplate, newTemplate );
        this.selectedTemplate = newTemplate;
        return;
      }
      this.selectedTemplate = this.workspaceService.data.addUserTemplate( newTemplate );
    } );
  }

  setTemplate ( close = true ) {
    if ( close ) this.activeModal.close();

    const template = this.selectedTemplate;

    if ( template == null )
      return;

    this.acharts.forEach( ac => ac.loadTemplate( template ) );
  }

  setTemplateToAll ( close = true ) {
    if ( close ) this.activeModal.close();

    const template = this.selectedTemplate;

    if ( template == null )
      return;

      if( this.workspaceService.data.charts["ach1"].instance)
      this.workspaceService.data.charts["ach1"].instance.loadTemplate( template )

      if( this.workspaceService.data.charts["ach2"].instance)
      this.workspaceService.data.charts["ach2"].instance.loadTemplate( template )

      if( this.workspaceService.data.charts["ach3"].instance)
      this.workspaceService.data.charts["ach3"].instance.loadTemplate( template )

      if( this.workspaceService.data.charts["ach4"].instance)
      this.workspaceService.data.charts["ach4"].instance.loadTemplate( template )
   // this.workspaceService.data

    

  //  this.acharts.forEach( ac => ac.loadTemplate( template ) );
  }


  initScroll ( nativeElement: any ) {
    $( nativeElement ).mCustomScrollbar( {
      axis: "y",
      theme: "inset-3", // "minimal-dark",
      scrollbarPosition: "inside",
      alwaysShowScrollbar: 1, // 0,1,2
      scrollButtons: {
        enable: true
      },
      mouseWheel: {
        enable: true
      }
    } );
  }

}
